<div class="modal-header">
    <h4 class="modal-title"> {{'save.title' | translate}} </h4>
  </div>
  <div class="modal-body pt-0">
    <div class="modal-body-inner">
      <p>{{'save.project.needed.popup.label' | translate}}</p>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" data-testid="close-button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
    <button type="button" data-testid="save-as-button" class="btn btn-secondary btn-forward" (click)="save(true)" >{{'global.label.saveAs' | translate}}</button>
    <button type="button" data-testid="save-button" class="btn btn-primary btn-forward" (click)="save(false)" >{{'global.label.save' | translate}}</button>
  </div>

